import React from "react";
import { interpolate, useCurrentFrame } from "remotion";
import { COLORS } from "../constants";

export const DataParticle: React.FC<{
  fromX: number;
  fromY: number;
  toX: number;
  toY: number;
  delay?: number;
  duration?: number;
  color?: string;
  size?: number;
  count?: number;
}> = ({
  fromX,
  fromY,
  toX,
  toY,
  delay = 0,
  duration = 40,
  color = COLORS.accentTeal,
  size = 6,
  count = 3,
}) => {
  const frame = useCurrentFrame();

  return (
    <>
      {Array.from({ length: count }).map((_, i) => {
        const particleDelay = delay + i * Math.floor(duration / count);
        const localFrame = frame - particleDelay;
        const loopFrame = localFrame % duration;

        if (localFrame < 0) return null;

        const progress = interpolate(loopFrame, [0, duration], [0, 1], {
          extrapolateRight: "clamp",
        });

        const x = fromX + (toX - fromX) * progress;
        const y = fromY + (toY - fromY) * progress;

        const opacity = interpolate(
          progress,
          [0, 0.1, 0.8, 1],
          [0, 1, 1, 0],
        );

        const particleSize = interpolate(
          progress,
          [0, 0.5, 1],
          [size * 0.5, size, size * 0.3],
        );

        return (
          <div
            key={i}
            style={{
              position: "absolute",
              left: x - particleSize / 2,
              top: y - particleSize / 2,
              width: particleSize,
              height: particleSize,
              borderRadius: "50%",
              background: color,
              opacity,
              boxShadow: `0 0 ${particleSize * 2}px ${color}, 0 0 ${particleSize * 4}px ${color}60`,
            }}
          />
        );
      })}
    </>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
